export const numberWithSpaces = {
  methods: {
    numberWithSpaces(value) {
      return value != undefined
        ? Array.from(
            value
              .replaceAll(/\D/g, "")
              .matchAll(/(\d{0,4})(\d{0,4})(\d{0,4})(\d{0,4})/g)
          )[0]
            .slice(1, 5)
            .join(" ")
            .trim()
        : "";
    },
  },
};
